import React, { useEffect, useState } from "react"
import { Modal } from "@mui/material"
import { Document, Page } from "react-pdf"
import { LuX } from "react-icons/lu"

const PdfViewModal = ({ pdf }) => {
  const [open, setOpen] = useState(false)
  const [heightModalContent, setHeightModalContent] = useState(580)

  const handleOpen = async () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const adjustHeight = () => {
    const maxHeight = 780
    const currentHeight = window.innerHeight
    if (currentHeight < 819) {
      const newHeight = Math.round((currentHeight / 795) * (maxHeight - 120))
      const finalHeight = Math.min(newHeight, maxHeight)
      setHeightModalContent(finalHeight)
    } else {
      setHeightModalContent(maxHeight)
    }
  }
  window.addEventListener('load', adjustHeight)
  window.addEventListener('resize', adjustHeight)

  useEffect(() => {
    adjustHeight()
  }, [])

  if (!pdf || typeof pdf !== "string") return null
  const isImage = ["data:image/png", "data:image/jpg", "data:image/jpeg"].includes(pdf.split(";base64").shift())
  return (
    <div>
      <div onClick={() => handleOpen()}>
        {isImage ? (
          <img src={pdf} alt="Image" />
        ) :
          <Document file={pdf}>
            <Page className="flex  " pageNumber={1} width={56} height={56} />
          </Document>}

      </div>
      <Modal
        open={open}
        closeAfterTransition
        onClose={handleClose}
      >
        <div className="flex items-center justify-center h-screen">
          <div
            className={`bg-paper border border-divider rounded-2xl fixed flex-col justify-between py-3 max-h-content max-w-[880px] min-h-[580px] w-content min-w-[480px] `}>
            <div className="absolute top-[20px] right-[20px] z-[999]">
              <div className="inline-flex justify-center items-center rounded-full cursor-pointer text-text-secondary"
                onClick={handleClose}>
                <LuX size={20} />
              </div>
            </div>
            <div className="overflow-auto" style={{ maxHeight: heightModalContent }}>
              {isImage ? (
                <img src={pdf} alt="Image" />
              ) :
                <Document file={pdf}>
                  <Page className="flex  " pageNumber={1} width={800} />
                </Document>}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}
export default PdfViewModal
